import { combineReducers } from 'redux';
import isMobile from './is-mobile.reducer'
// import toggle from './toggle.reducer'
// import authReducer from './auth.reducer';
import { loadingReducer } from './loadingReducer';
import { errorReducer } from './errorReducer';
import catalogs from './catalog.reducer'
// import recipient from './recipient.reducer'
// import cargo from './cargo.reducer'
// import commissionCreate from './commissionCreate.reducer'
import socialCommunity from './socialComuniti.reducer'

const hummanApp = combineReducers({
    isMobile,
    // auth: authReducer,
    isFatching: loadingReducer,
    error: errorReducer,
    // recipient: recipient,
    catalogs: catalogs,
    // cargo,
    // toggle,
    // commissionCreate,
    socialCommunity
})

const rootReducer = (state, action) => {
    // console.log(action.type)
    if (action.type === 'LOGOUT_USER') {
      state = undefined
    }
  
    return hummanApp(state, action)
  }

export default rootReducer